const textEncoder = new TextEncoder();

const fromStringToBytes = (string) => textEncoder.encode(string);

// noinspection JSUnusedGlobalSymbols
export default fromStringToBytes;
